<template>
    <!--城市检测-->
    <el-submenu
            :popper-append-to-body="false"
            v-if="menu.id===5"
            :index="menu.id +''"
    >
        <template slot="title">
            <span>{{ menu.name }}</span>
        </template>
        <tl-sub-menu
                v-for="item in cityListMenu"
                :key="item.id +''"
                :menu="item"
        >
        </tl-sub-menu>

    </el-submenu>
    <!--区域成因-->
    <el-submenu
            :popper-append-to-body="false"
            v-else-if="menu.id===6"
            :index="menu.id +''"
    >
        <template slot="title">
            <span>{{ menu.name }}</span>
        </template>

        <tl-sub-menu
                v-for="item in causeAnalysisMenu"
                :key="item.id +''"
                :menu="item"
        >
        </tl-sub-menu>
    </el-submenu>
    <!--正产菜单-->
    <el-submenu
            :popper-append-to-body="false"
            v-else-if="menu.list && menu.list.length >= 1"
            :index="menu.id +''"
    >
        <template slot="title">
            <span>{{ menu.name }}</span>
        </template>
        <tl-sub-menu
                v-for="item in menu.list"
                :key="item.id +''"
                :menu="item"
        >
        </tl-sub-menu>
    </el-submenu>
    <el-menu-item v-else :index="menu.id+''" @click="gotoRouteHandle(menu)">
        <span>{{ menu.name }}</span>
    </el-menu-item>
</template>

<script>
    import tlSubMenu from './main-sidebar-sub-menu'
    import url from "../../utils/UrlApi"

    export default {
        name: 'tl-sub-menu',
        props: {
            menu: {
                type: Object,
                required: true
            },
        },
        computed: {
            DSTTagsList: {
                get() {
                    return this.$store.state.DSTTagsList
                },
                set(val) {
                    this.$store.commit("updateDSTTagsList", val);
                }
            },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
            },
            // 成因分析 菜单 列表
            causeAnalysisMenu() {
                let data = JSON.parse(JSON.stringify(this.$store.getters.getCauseAnalysisData));
                let menu = [];
                if (data.length) {
                    menu = data.map(item => {
                        delete item.children;
                        item.url = 'CauseAnalysis'
                        item.id = item.menuId
                        item.name = item.title
                        item.query = JSON.stringify({id: item.menuId})
                        return item;
                    })
                }
                return menu;
            },
            // 城市监测菜单 列表
            cityListMenu() {
                let data = JSON.parse(JSON.stringify(this.$store.getters.getCityListData));
                let menu = [];
                if (data.length) {
                    menu = data.map(item => {
                        delete item.children;
                        item.url = 'CityMonitor'
                        item.id = item.menuId
                        item.name = item.title
                        item.query = JSON.stringify({id: item.menuId})
                        return item;
                    })
                }
                return menu;
            },
        },
        components: {
            tlSubMenu
        },
        methods: {
            // 通过menuId与动态(菜单)路由进行匹配跳转至指定路由
            gotoRouteHandle(item) {
                // console.log(item)

                // debugger
                //  先判断是否是外部链接
                if (item.type === 3 && item.url) {
                    let urls = item.url
                    console.log(urls)
                    window.open(urls, '_blank')
                    return
                }

                //  风场图 单独跳转
                if (item.url === 'Wind') {
                    let urls = url.windy + "?city=" + this.gpsState.city + '&timer=' + new Date().getTime() + '&cityCode=' + this.gpsState.cityCode
                    window.open(urls, '_blank')
                    return
                }

                //  成因分析 菜单 路由单独处理
                if (item.url === 'WebAnalysis') {
                    this.$http.get(url.gzDataToken, {
                        params: {}
                    }).then(res => {

                        if (res.data.code==='200'){
                            let urls =`https://dst.cleanair.work/project-brow?id=${res.data.data.id}&token=`+res.data.data.token
                            window.open(urls, '_blank')
                        }else {
                            this.$message.error(res.data.message)
                        }
                    })


                    // let urls ='https://dst.cleanair.work/project-brow?id=1310528829572616194&token='
                    // window.open(urls, '_blank')
                    return
                }

                // 光污染 菜单特殊处理

                if (item.url === 'GHX_PollutionLevel') {
                    item.query = JSON.stringify({id: item.id, menuId: item.menuId, name: item.name})
                    this.$router.push({name: item.url, query: JSON.parse(item.query)})
                    this.handleDSTTagsList(item)
                    return
                }

                //  专业图表菜单 特殊处理
                if (item.url === 'DataPresentation') {
                    item.query = JSON.stringify({menuId: item.menuId,name: item.name})
                    this.$router.push({name: item.url, query: JSON.parse(item.query)})
                    this.handleDSTTagsList(item)
                    return
                }

                if (item.query) {
                    this.$router.push({name: item.url, query: JSON.parse(item.query)})
                    this.handleDSTTagsList(item)
                } else {
                    this.$router.push({name: item.url})
                    this.handleDSTTagsList(item)
                }
            },
            handleDSTTagsList(item) {
                let List = JSON.parse(JSON.stringify(this.DSTTagsList))
                let isExist = false
                for (let i = 0; i < List.length; i++) {
                    if (List[i].url === item.url && List[i].query === item.query) {
                        isExist = true
                    }
                }

                if (!isExist) {
                    List.push(item)
                    this.DSTTagsList = List
                }
            },
        }
    }
</script>
